import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import "./ContactPage.css";
import Text from "../../Components/Text/Text";
import { RotatingLines } from "react-loader-spinner";
import { Helmet } from 'react-helmet';


export default function ContactPage() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const bodyRef = useRef(document.body);

  // CODE FOR PAGE SLIDE ANIMATION
  useEffect(() => {
    // Add the "show" class after the component mounts to trigger the slide-in effect
    setIsVisible(true);

    // Remove the overflow-x: hidden when the animation completes
    return () => {
      bodyRef.current.style.overflowX = "auto";
    };
  }, []);

  useEffect(() => {
    // Hide the scrollbar on the x-axis when the slide-in animation is active
    if (isVisible) {
      bodyRef.current.style.overflowX = "hidden";
    }
  }, [isVisible]);
  // CODE FOR PAGE SLIDE ANIMATION END

  function ContactForm() {
    const [formData, setFormData] = useState({});

    function validEmail(email) {
      var re =
        /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      return re.test(email);
    }

    function validateHuman(honeypot) {
      if (honeypot) {
        console.log("Robot Detected!");
        return true;
      } else {
        console.log("Welcome Human!");
      }
    }

    function getFormData(form) {
      var elements = form.elements;

      var fields = Object.keys(elements)
        .filter(function (k) {
          return elements[k].name !== "honeypot";
        })
        .map(function (k) {
          if (elements[k].name !== undefined) {
            return elements[k].name;
          } else if (elements[k].length > 0) {
            return elements[k].item(0).name;
          }
        })
        .filter(function (item, pos, self) {
          return self.indexOf(item) == pos && item;
        });

      var formData = {};
      fields.forEach(function (name) {
        var element = elements[name];
        formData[name] = element.value;
        if (element.length) {
          var data = [];
          for (var i = 0; i < element.length; i++) {
            var item = element.item(i);
            if (item.checked || item.selected) {
              data.push(item.value);
            }
          }
          formData[name] = data.join(", ");
        }
      });

      // add form-specific values into the data
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = form.dataset.sheet || "Sheet1"; // default sheet name
      formData.formGoogleSendEmail = form.dataset.email || ""; // no email by default

      console.log(formData);
      return formData;
    }

    function handleFormSubmit(event) {
      event.preventDefault();
      const form = event.target;
      const data = getFormData(form);

      if (data.email && !validEmail(data.email)) {
        var invalidEmail = form.querySelector(".email-invalid");
        if (invalidEmail) {
          invalidEmail.style.display = "block";
          return false;
        }
      } else {
        // disableAllButtons(form);
        setLoading(true); // Show loading animation
        var url = form.action;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded"
        );
        xhr.onreadystatechange = function () {
          // console.log(xhr.status, xhr.statusText);
          // console.log(xhr.responseText);
          if (xhr.readyState === 4) {
            // Check if the request is complete
            if (xhr.status === 200) {
              setSuccess(true); // Form sent successfully
              setLoading(false); // Hide loading animation
            } else {
              // Handle any error here
              setLoading(false); // Hide loading animation
            }
          }
        };
        var encoded = Object.keys(data)
          .map(function (k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
          })
          .join("&");
        xhr.send(encoded);
      }
    }

    function disableAllButtons(form) {
      var buttons = form.querySelectorAll("button");
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
      }
    }

    return (
      <form
        className="gform pure-form pure-form-stacked"
        onSubmit={handleFormSubmit}
        data-email="info@haganlubricants.com"
        // data-email="muslimhussain89@gmail.com"
        action="https://script.google.com/macros/s/AKfycbzsEIV6Ir3Hb0lSY_dmaTZ2cHhDOq9mkZ0OwGRYHHF6xb-wnc2tsG8S-RJmjoqA8ei3mA/exec"
      >
        <input type="text" name="Name" placeholder="Name" required />
        <input type="email" name="Email" placeholder="Email" required />
        <input type="text" name="Mobile" placeholder="Mobile Number" />
        <textarea
          name="Message"
          cols="10"
          rows="1"
          placeholder="What would you like to discuss"
          required
        ></textarea>
        {loading ? (
          <div className="loading-animation">
            <RotatingLines
              strokeColor="grey"
              strokeWidth="5"
              animationDuration="0.75"
              width="76"
              visible={true}
            />
          </div>
        ) : success ? (
          <div className="thankyou_message">
            <h1>Thanks for contacting us!</h1>
            <div className="close-btn">
              <button onClick={() => window.location.reload()}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
              </button>
            </div>
          </div>
        ) : (
          <button className="submit press-effect">send</button>
        )}
      </form>
    );
  }

  return (
    <div className="TopParent">
    <Helmet>
        <title>Contact Us</title>
      </Helmet>
        <Navbar  LogoSrc={"/images/hagan_logo.svg"} />
      <div className={`ProductPageParent ${isVisible ? "show" : ""}`}>
        {/* <Image Src={"/images/HomePage/HomePageBG.webp"} Width={"100%"} /> */}
        <div className="ContactUsParent">
          <div className="contactForm">
            {/* <h2>Contact Us</h2> */}
            <ContactForm />
            <div className="bottomText">
              <div className="officelocationAddress">
                <div className="OfficeAddressSec">
                  <Text
                    text="Hagan Lubricants Dubai"
                    Color="white"
                    FontSize="2rem"
                    Margin="25px 0px 15px 0px"
                  />
                  <Text
                    FontSize="1.6rem"
                    Color="#B5B5B5"
                    Margin="25px 0px 15px 0px"
                    text="Momin Oil Industry FZCO P.O. Box: 61292. R/A # 7 Jebel Ali Free Zone. Dubai, UAE"
                  />
                  <Text
                    FontSize="1.6rem"
                    Color="#B5B5B5"
                    Margin="25px 0px 5px 0px"
                    text="P: 0097148819717"
                  />

                  <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@moifzco.ae">
                    E: info@moifzco.ae
                  </a>
                  <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@haganlubricants.com">
                    E: info@haganlubricants.com
                  </a>
                 
                </div>
                <div className="OfficeAddressSec">
                  <Text
                    text="Hagan Lubricants Pakistan"
                    Color="white"
                    FontSize="2rem"
                    Margin="25px 0px 15px 0px"
                  />
                  <Text
                    FontSize="1.6rem"
                    Color="#B5B5B5"
                    Margin="25px 0px 15px 0px"
                    text="House#135 P Block Model Town lahore"
                  />
                  <Text
                    FontSize="1.6rem"
                    Color="#B5B5B5"
                    Margin="25px 0px 5px 0px"
                    text="P: 04235977765, 04235977795"
                  />

                  <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@haganlubricants.com">
                    {" "}
                    E: info@haganlubricants.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
